<div class="lang-menu">
  <ul class="language-options">
    <li (click)="changeLanguage('en')">
      <a>English</a>
      <mat-icon [ngClass]="{ isSelected: isEnglish }">done</mat-icon>
    </li>
    <li (click)="changeLanguage('es')">
      <a>Español</a>
      <mat-icon [ngClass]="{ isSelected: isSpanish }">done</mat-icon>
    </li>
  </ul>
</div>
